import { MenuItemsModel } from '@core/menu/menu.model';
import { RouteEntity } from '@core/router/route.entity';
import { PrivilegesModules } from '@core/privileges/privileges-modules';
import { marker } from '@colsen1991/ngx-translate-extract-marker';


export const submenu: MenuItemsModel[] = [
    {
        mdId: 1,
        mdName: marker('modules.users.head'),
        url: RouteEntity.Root + RouteEntity.Users,
        objName: [PrivilegesModules.AcmanUsers],
    },
    {
        mdId: 2,
        mdName: marker('modules.divisions.head'),
        url: RouteEntity.Root + RouteEntity.Divisions,
        objName: [PrivilegesModules.AcmanUsers],
    },
    {
        mdId: 3,
        mdName: marker('modules.orgRoles.head'),
        url: RouteEntity.Root + RouteEntity.OrgRoles,
        objName: [PrivilegesModules.AcmanOrgRoles],
    },
    {
        mdId: 4,
        mdName: marker('modules.partners.head'),
        url: RouteEntity.Root + RouteEntity.Partners,
        objName: [PrivilegesModules.AcmanUsers],
    },
];

export const thirdLevelMenu: { [key: string]: MenuItemsModel[] } = {};
